<div class="container">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="text-center">
            <h1>404</h1>
            <h2 l10nTranslate>notFound.message</h2>
        </div>
    </div>
</div>